import * as common from '@/store/common/mutation-types';
export const SET = 'SET';
export const SEARCH_PARAM = 'SEARCH_PARAM';
export const STATE_INIT = 'STATE_INIT';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const PAGING_INFO = 'PAGING_INFO';
export const CMPN_MST_POPUP = 'CMPN_MST_POPUP';
export const STATE_CMPN_MST_INIT = 'STATE_CMPN_MST_INIT';
export const OP_CD_SEARCH_PARAMS = 'OP_CD_SEARCH_PARAMS';
export const POP_UP_PAGING_INFO = 'POP_UP_PAGING_INFO';
export const OP_CD_SEARCH_PARAMS_INIT = 'OP_CD_SEARCH_PARAMS_INIT';

export default {
	...common,
	SET,
	SEARCH_PARAM,
	STATE_INIT,
	DEFAULT_ASSIGN,
	PAGING_INFO,
	POP_UP_PAGING_INFO,
	CMPN_MST_POPUP,
	STATE_CMPN_MST_INIT,
	OP_CD_SEARCH_PARAMS,
	OP_CD_SEARCH_PARAMS_INIT
};
